import { render, staticRenderFns } from "./ArgsPicker.vue?vue&type=template&id=2ddc87a4"
import script from "./ArgsPicker.vue?vue&type=script&lang=js"
export * from "./ArgsPicker.vue?vue&type=script&lang=js"
import style0 from "./ArgsPicker.vue?vue&type=style&index=0&id=2ddc87a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports